import React, { useRef, useState } from "react";
import HTMLFlipBook from "react-pageflip";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Helmet } from "react-helmet-async";

const pages = [
  "/journey/page1.jpg",
  "/journey/page2.jpg",
  "/journey/page3.jpg",
  "/journey/page4.jpg",
  "/journey/page5.jpg",
  "/journey/page6.jpg",
  "/journey/page7.jpg",
  "/journey/page8.jpg",
  "/journey/page9.jpg",
  "/journey/page10.jpg",
  "/journey/page11.jpg",
  "/journey/page12.jpg",
  "/journey/page13.jpg",
  "/journey/page14.jpg",
  "/journey/page15.jpg",
  "/journey/page16.jpg",
  "/journey/page17.jpg",
  "/journey/page18.jpg",
  "/journey/page19.jpg",
  "/journey/page20.jpg",
  "/journey/page21.jpg",
  "/journey/page22.jpg",
  "/journey/page23.jpg",
  "/journey/page24.jpg",
  "/journey/page25.jpg",
];

export default function Journey() {
  const book = useRef(null);
  const [page, setPage] = useState(1);

  const nextPage = () => {
    book.current.pageFlip().flipNext();
  };

  const prevPage = () => {
    book.current.pageFlip().flipPrev();
  };

  return (
    <>
      <Helmet>
        <title>Journey | Gandhi Mandela Foundation</title>
        <meta name="description" content="Journey" />
      </Helmet>
      
      <Header />

      <section className="page-header">
        <div className="container">
          <div className="breadcrumb">
            <a href="/">Home</a>
            <span>/</span>
            <span>Journey</span>
          </div>

          <h1>Journey</h1>
        </div>
      </section>

      <section className="section">
        <div className="container flipbook-container">

          <HTMLFlipBook
            ref={book}
            width={600}
            height={600}
            size="stretch"
            minWidth={280}
            maxWidth={700}
            minHeight={500}
            maxHeight={900}
            showCover={true}
            mobileScrollSupport={true}
            drawShadow={true}
            onFlip={(e) => setPage(e.data + 1)}
          >
            {pages.map((img, index) => (
              <div className="book-page" key={index}>
                <img src={img} alt={`Page ${index + 1}`} />

                <div className="page-corner top">
                  <i className="fa-solid fa-hand-pointer"></i>
                </div>

                <div className="page-corner bottom">
                  <i className="fa-solid fa-hand-pointer"></i>
                </div>
              </div>
            ))}
          </HTMLFlipBook>

          <div className="page-count">
            {page} / {pages.length}
          </div>

          <div className="swipe-hint">
            <i className="fa-solid fa-hand-point-up"></i>
            Swipe or use buttons below to turn pages
          </div>

          <div className="mobile-controls">
            <button onClick={prevPage}>
              <i className="fa-solid fa-chevron-left"></i> Previous
            </button>

            <button onClick={nextPage}>
              Next <i className="fa-solid fa-chevron-right"></i>
            </button>
          </div>

        </div>
      </section>

      <Footer />
    </>
  );
}